import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from 'react-loader-spinner';

import Confirm from '../Dialog/Confirm';
import { opbMngService, opbcdtService } from '../../services';
import { alertActions } from '../../modules/alert';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

class BottomButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            pubStatus: false,
            groupPubCount: 0
        };
    }

    handleModButton = () => {
        this.props.setSubmitted();

        let formData = new FormData();
        formData.append("siteID", this.props.opbInfo.siteID);
        formData.append("opbID", this.props.opbInfo.opbID);
        opbcdtService.selectedOpb(formData)
            .then(response => {
                const connectYN = response.data.connectYN ? response.data.connectYN : "N";
                if (connectYN === "Y" && this.validation()) { this.modOpb(); }
                else if (connectYN === "Y") { return null; }
                else { this.props.errorAlerts("Display 연결이 끊겼습니다. 확인 후 이용해주세요."); }
            })
            .catch(this.handleErrors);
    };

    validation = () => {
        const { opbInfo } = this.props;
        const { opbName, boardCode, typeCode, floorStartType, floorStart, floorEnd, patchStandard, slotCode } = opbInfo;
        if (!opbName) {
            this.props.errorAlerts("호기 이름은 필수 입력 값입니다.");
            return false;
        } else if (!boardCode || !typeCode) {
            this.props.errorAlerts("타입은 필수 입력 값입니다.");
            return false;
        } else if (!floorStartType || (floorStartType === "지하" && parseInt(floorStart) === 0)) {
            this.props.errorAlerts("최저층 정보는 필수 입력 값입니다.");
            return false;
        } else if (!floorEnd || parseInt(floorEnd) === 0) {
            this.props.errorAlerts("최고층 정보는 필수 입력 값입니다.");
            return false;
        } else if (!patchStandard) {
            this.props.errorAlerts("패치설정은 필수 입력 값입니다.");
            return false;
        } else if (!slotCode) {
            this.props.errorAlerts("Display위치는 필수 입력 값입니다.");
            return false;
        } else
            return true;
    };

    modOpb = () => {
        const { opbInfo } = this.props;
        const { siteID, opbNo, opbID, opbName, floorStartType, floorStart, floorEnd, boardCode, typeCode, elvNo, patchStandard, slotCode, contractYN } = opbInfo;

        // 지상일 경우 무조건 10(1층을 의미함)부터 시작한다.
        // 지하일 경우 10에서 입력값을 뺀다.
        const newFloorStart = floorStartType === "지상" ? 10 : 10 - parseInt(floorStart);
        const opbStatus = contractYN === "Y" ? "ST001" : "ST002";

        let formData = new FormData();
        formData.append('siteID', siteID);
        formData.append('opbNo', opbNo);
        formData.append('opbID', opbID);
        formData.append("opbName", opbName);
        formData.append('floorStart', newFloorStart);
        formData.append('floorEnd', parseInt(floorEnd) + 9);
        formData.append('opbStatus', opbStatus);
        formData.append("boardCode", boardCode);
        formData.append("typeCode", typeCode);
        formData.append("elvNo", elvNo);
        formData.append("slotCode", slotCode);
        formData.append("patchStandard", patchStandard);

        opbMngService.modOpbInfo(formData)
            .then((response) => {
                if (response.status === 200) {
                    this.props.successAlerts('변경된 사항을 적용하였습니다.');
                    this.props.stateRefresh();
                }
            })
            .catch(this.handleErrors);
    };


    handleCaptureButton = () => {
        const { opbInfo, myInfo } = this.props;

        let formData = new FormData();
        formData.append("siteID", opbInfo.siteID);
        formData.append("opbID", opbInfo.opbID);
        opbcdtService.selectedOpb(formData)
            .then(response => {
                let paramOpbInfo = { ...opbInfo };
                const connectYN = response.data.connectYN ? response.data.connectYN : "N";
                if (connectYN === "Y") {
                    console.log("캡처 버튼 클릭 시 opbInfo 정보");
                    console.log(paramOpbInfo);

                    paramOpbInfo.imei = (paramOpbInfo.imei ? paramOpbInfo.imei : "");
                    paramOpbInfo.pubType = "now";
                    paramOpbInfo.pubReg = "user"; // user / system / scheduler
                    paramOpbInfo.pubUser = myInfo.userID;
                    paramOpbInfo.gbn = "capture";

                    if (paramOpbInfo.imei) {
                        // 캡처 완료까지 캡처 버튼 비활성화
                        this.setState({
                            pubStatus: true
                        });

                        formData = new FormData();
                        formData.append('imei', paramOpbInfo.imei);
                        formData.append('pubType', paramOpbInfo.pubType);
                        formData.append('pubReg', paramOpbInfo.pubReg);
                        formData.append('pubUser', paramOpbInfo.pubUser);
                        formData.append('gbn', paramOpbInfo.gbn);

                        opbcdtService.publishSend(formData)
                            .then(response2 => {
                                this.setState({
                                    pubStatus: false
                                });
                                console.log("배포 완료");
                                this.props.errorAlerts("요청이 완료되었습니다. 새로고침 하세요.");
                            })
                            .catch(error => {
                                this.setState({
                                    pubStatus: false
                                });
                                this.handleErrors(error);
                            });
                    }
                    else { this.props.errorAlerts("IMEI 정보를 확인하세요."); }
                }
                else { this.props.errorAlerts("Display연결이 끊겼습니다. 확인 후 이용해주세요."); }
            })
            .catch(this.handleErrors);
    };

    handleRefreshButton = () => {
        this.props.handleRefreshButton();
    };

    handleGoPrevButton = () => {
        // 이전 스텝으로 이동
        const { activeTabId = 1 } = this.props;
        this.props.handleActiveTabIdChange(activeTabId - 1);
    };

    handleGoNextButton = () => {
        // 다음 스텝으로 이동
        const { activeTabId = 1 } = this.props;
        this.props.handleActiveTabIdChange(activeTabId === 5 ? 3 : activeTabId + 1);
    };

    handleGoButton = () => {
        // 배포 화면으로 이동
        let activeTabId = 9;
        // 템플릿 유효성검사
        let templateValidation = true;
        const { templateID, layoutThemeID, keypadThemeID } = this.props.opbInfo;

        if (templateID === 0 || layoutThemeID === 0 || keypadThemeID === 0) {
            templateValidation = false;
            activeTabId = 4;
        }

        // 시간 기반 - 시작시간,종료시간 유효성검사
        let timeValidation = true;
        let validationIndex = 0;
        if (this.props.opbInfo.promotionList.length > 0) {
            this.props.opbInfo.promotionList.map((promotion, i) => {
                if (promotion.enabledTime === 1 && promotion.startTime > promotion.endTime) {
                    timeValidation = false;
                    validationIndex = validationIndex ? validationIndex : i + 1;
                    activeTabId = 7;
                }
                return promotion;
            });
        }
        if (this.props.opbInfo.marketingList.length > 0) {
            this.props.opbInfo.marketingList.map((marketing, i) => {
                if (marketing.enabledTime === 1 && marketing.startTime > marketing.endTime) {
                    timeValidation = false;
                    validationIndex = validationIndex ? validationIndex : i + 1;
                    activeTabId = 8;
                }
                return marketing;
            });
        }
        if (this.props.opbInfo.bottomList?.length > 0) {
            this.props.opbInfo.bottomList.map((content, i) => {
                if (content.enabledTime === 1 && content.startTime > content.endTime) {
                    timeValidation = false;
                    validationIndex = validationIndex ? validationIndex : i + 1;
                    activeTabId = 11;
                }
                return content;
            });
        }

        if (!timeValidation) {
            this.props.errorAlerts(validationIndex + "번 : 시작시간이 종료시간보다 늦을 수 없습니다.");
        }
        else if (!templateValidation) {
            this.props.errorAlerts("템플릿을 선택하세요.");
        }

        // 배포(activeTabId:9) 또는 수정필요한 화면으로 이동
        this.props.handleMoveConfirm(activeTabId);
    };

    // 컨텐츠 전체삭제 기능
    handleContentsDel = () => {
        this.props.handleContentsDel(this.props.contentTypeCode);
    };

    // 컨텐츠 추가 기능
    setContentListAdd = (contentTypeCode, addList, addContentType) => {
        this.props.setContentListAdd(contentTypeCode, addList, addContentType);
    };

    handleSubmitButton = () => {
        const { opbInfo, myInfo } = this.props;

        if (opbInfo.groupStatus && opbInfo.checkedOpbIDs.length === 0) {
            // 그룹배포 Display선택 여부 체크
            this.props.errorAlerts("선택된 Display가 없습니다.");
            this.props.handleMoveConfirm(10);
        }
        else if (opbInfo.groupStatus && opbInfo.checkedOpbIDs.length > 0) {
            // 그룹배포
            this.setState({
                groupPubCount: 0
            });
            opbInfo.checkedOpbIDs.map(checkedOpbID => this.handleGroupPublish(checkedOpbID));
        }
        else {
            // 개별배포

            // connectYN 재확인
            let formData = new FormData();
            formData.append("siteID", opbInfo.siteID);
            formData.append("opbID", opbInfo.opbID);
            opbcdtService.selectedOpb(formData)
                .then(response => {
                    let paramOpbInfo = { ...opbInfo };
                    const connectYN = response.data.connectYN ? response.data.connectYN : "N";

                    if (connectYN === "Y") {
                        paramOpbInfo.userID = myInfo.userID;
                        paramOpbInfo.ip = "0:0:0:0:0:0:0:1";
                        paramOpbInfo.logContent = "opbID=" + paramOpbInfo.opbID;
                        paramOpbInfo.imei = (paramOpbInfo.imei ? paramOpbInfo.imei : "");
                        paramOpbInfo.pubReg = "user";
                        paramOpbInfo.pubUser = myInfo.userID;
                        const config = paramOpbInfo.templateStatus || paramOpbInfo.floorsStatus || paramOpbInfo.bottomStatus ? "config" : "";
                        const content = paramOpbInfo.promotionStatus || paramOpbInfo.marketingStatus || paramOpbInfo.bottomStatus ? "content" : "";
                        paramOpbInfo.gbn = config && content ? "all" : (config || content ? config || content : "all");

                        // floorID 설정
                        paramOpbInfo.floorsList = paramOpbInfo.floorsList.map(floor => {
                            floor.floorID = (floor.floorID === 0 ? -1 : floor.floorID);
                            return floor;
                        });

                        // promotion, marketing, bottom 설정
                        paramOpbInfo.promotionList.map((promotion, i) => {
                            if (!promotion.startTime) promotion.startTime = "00:00:00";
                            if (!promotion.endTime) promotion.endTime = "23:59:59";
                            if (!promotion.contentVolume) promotion.contentVolume = 0;
                            promotion.sort = i + 1;
                            return promotion;
                        });
                        paramOpbInfo.marketingList.map((marketing, i) => {
                            if (!marketing.startTime) marketing.startTime = "00:00:00";
                            if (!marketing.endTime) marketing.endTime = "23:59:59";
                            if (!marketing.contentVolume) marketing.contentVolume = 0;
                            marketing.sort = i + 1;
                            return marketing;
                        });
                        paramOpbInfo.bottomList.map((bottom, i) => {
                            if (!bottom.startTime) bottom.startTime = "00:00:00";
                            if (!bottom.endTime) bottom.endTime = "23:59:59";
                            if (!bottom.contentVolume) bottom.contentVolume = 0;
                            bottom.sort = i + 1;
                            return bottom;
                        });

                        console.log("배포 버튼 클릭 후 paramOpbInfo 정보");
                        console.log(paramOpbInfo);
                        console.log(JSON.stringify(paramOpbInfo));

                        // 배포 완료까지 배포 버튼 비활성화
                        this.setState({
                            pubStatus: true
                        });

                        opbcdtService.setOpbState(JSON.stringify(paramOpbInfo))
                            .then(response2 => {
                                console.log("DB저장 완료");
                                console.log(response2.data);

                                formData = new FormData();
                                formData.append('imei', paramOpbInfo.imei);
                                formData.append('pubType', paramOpbInfo.pubType);
                                formData.append('pubReg', paramOpbInfo.pubReg);
                                formData.append('pubUser', paramOpbInfo.pubUser);
                                formData.append('gbn', paramOpbInfo.gbn);

                                opbcdtService.publishSend(formData)
                                    .then(response3 => {
                                        console.log("배포 완료");
                                        console.log(response3.data);

                                        this.props.handleClose();
                                    })
                                    .catch(error2 => {
                                        this.setState({
                                            pubStatus: false
                                        });
                                        this.handleErrors(error2);
                                        this.props.errorAlerts("배포 서버 오류 발생! 잠시 후 다시 이용해주세요.");
                                    });
                            })
                            .catch(error => {
                                this.setState({
                                    pubStatus: false
                                });
                                this.handleErrors(error);
                                this.props.errorAlerts("배포 실패하였습니다.");
                            });
                    }
                    else { this.props.errorAlerts("Display연결이 끊겼습니다. 확인 후 이용해주세요."); }
                })
                .catch(this.handleErrors);
        }
    };

    handleGroupPublish = (checkedOpbID) => {
        const { opbInfo, myInfo } = this.props;

        let formData = new FormData();
        formData.append("siteID", opbInfo.siteID);
        formData.append("opbID", checkedOpbID);
        opbcdtService.selectedOpb(formData)
            .then(response => {
                let paramOpbInfo = { ...opbInfo };
                const selectedOpbInfo = response.data;
                const connectYN = response.data.connectYN ? response.data.connectYN : "N";

                paramOpbInfo.opbID = selectedOpbInfo.opbID;
                paramOpbInfo.opbNo = selectedOpbInfo.opbNo;
                paramOpbInfo.imei = selectedOpbInfo.imei;
                paramOpbInfo.userID = myInfo.userID;
                paramOpbInfo.ip = "0:0:0:0:0:0:0:1";
                paramOpbInfo.logContent = "opbID=" + selectedOpbInfo.opbID;
                paramOpbInfo.pubReg = "user";
                paramOpbInfo.pubUser = myInfo.userID;
                const config = paramOpbInfo.templateStatus || paramOpbInfo.floorsStatus || paramOpbInfo.bottomStatus ? "config" : "";
                const content = paramOpbInfo.promotionStatus || paramOpbInfo.marketingStatus || paramOpbInfo.bottomStatus ? "content" : "";
                paramOpbInfo.gbn = config && content ? "all" : (config || content ? config || content : "all");    // config / content / all

                // promotion, marketing, bottom 설정
                paramOpbInfo.promotionList.map((promotion, i) => {
                    if (!promotion.startTime) promotion.startTime = "00:00:00";
                    if (!promotion.endTime) promotion.endTime = "23:59:59";
                    if (!promotion.contentVolume) promotion.contentVolume = 0;
                    promotion.sort = i + 1;
                    promotion.opbID = paramOpbInfo.opbID;
                    return promotion;
                });
                paramOpbInfo.marketingList.map((marketing, i) => {
                    if (!marketing.startTime) marketing.startTime = "00:00:00";
                    if (!marketing.endTime) marketing.endTime = "23:59:59";
                    if (!marketing.contentVolume) marketing.contentVolume = 0;
                    marketing.sort = i + 1;
                    marketing.opbID = paramOpbInfo.opbID;
                    return marketing;
                });
                paramOpbInfo.bottomList.map((bottom, i) => {
                    if (!bottom.startTime) bottom.startTime = "00:00:00";
                    if (!bottom.endTime) bottom.endTime = "23:59:59";
                    if (!bottom.contentVolume) bottom.contentVolume = 0;
                    bottom.sort = i + 1;
                    bottom.opbID = paramOpbInfo.opbID;
                    return bottom;
                });

                // deletaList 설정
                if (paramOpbInfo.promotionStatus) selectedOpbInfo.promotionList.map(promotion => paramOpbInfo.deleteList.push(promotion.opbcontentID));
                if (paramOpbInfo.marketingStatus) selectedOpbInfo.marketingList.map(marketing => paramOpbInfo.deleteList.push(marketing.opbcontentID));
                if (paramOpbInfo.bottomStatus) selectedOpbInfo.bottomList.map(bottom => paramOpbInfo.deleteList.push(bottom.opbcontentID));

                console.log("배포 버튼 클릭 후 paramOpbInfo 정보");
                console.log(paramOpbInfo);
                console.log(JSON.stringify(paramOpbInfo));

                // 배포 완료까지 배포 버튼 비활성화
                this.setState({
                    pubStatus: true
                });

                opbcdtService.setOpbState(JSON.stringify(paramOpbInfo))
                    .then(response2 => {
                        if (connectYN === "Y") {
                            formData = new FormData();
                            formData.append('imei', paramOpbInfo.imei);
                            formData.append('pubType', paramOpbInfo.pubType);
                            formData.append('pubReg', paramOpbInfo.pubReg);
                            formData.append('pubUser', paramOpbInfo.pubUser);
                            formData.append('gbn', paramOpbInfo.gbn);

                            opbcdtService.publishSend(formData)
                                .then(response3 => {
                                    // 모든 그룹배포 완료여부 확인
                                    this.setGroupPubCount(paramOpbInfo.checkedOpbIDs, paramOpbInfo.pubType);
                                })
                                .catch(error2 => {
                                    this.setState({
                                        pubStatus: false
                                    });
                                    this.handleErrors(error2);
                                    this.props.errorAlerts("배포 서버 오류 발생! 잠시 후 다시 이용해주세요.");
                                });
                        }
                        else {
                            // 모든 그룹배포 완료여부 확인
                            this.setGroupPubCount(paramOpbInfo.checkedOpbIDs, paramOpbInfo.pubType);
                        }
                    })
                    .catch(error => {
                        this.setState({
                            pubStatus: false
                        });
                        this.handleErrors(error);
                        this.props.errorAlerts("배포(" + paramOpbInfo.imei + ") 실패하였습니다.");
                    });
            })
            .catch(this.handleErrors);
    };

    setGroupPubCount = (checkedOpbIDs, pubType) => {
        this.setState({
            groupPubCount: this.state.groupPubCount + 1
        });
        if (this.state.groupPubCount === checkedOpbIDs.length) {
            this.props.successAlerts("모든 " + (pubType === "derv" ? "예약" : "즉시") + "배포가 완료되었습니다.");
            this.props.handleClose();
        }
    };

    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    };

    handleClickOpenPreview = () => {
        this.props.handleClickOpenPreview();
    };

    handleOpenPreview = () => {
        this.props.handleOpenPreview();
    }

    handleConfirmOpen = () => {
        this.setState({
            open: true
        });
    };

    handleConfirmClose = () => {
        this.setState({
            open: false,
        });
    };

    render() {
        const { opbInfo, opbInfoStatus, mode } = this.props;
        const { siteID, opbID, opbNo, coBeginDate, coEndDate } = opbInfo;
        return (
            <div className="opbstate-bottom-button-wrapper" style={{ height: this.state.pubStatus ? "100%" : "" }}>
                {this.state.pubStatus
                    ?
                    <div className="text-align-center">
                        <Loader
                            type="Rings"
                            color="#00BFFF"
                            height={'50%'}
                            width={'50%'}
                        />
                    </div>
                    :
                    <>
                        <div className="opbstate-modify-pane-button-wrapper">
                            {mode === "mod" &&
                                <button className={`button w100-button ${(!opbInfoStatus) && " disabled-button"}`} variant="contained" color="primary" onClick={this.handleConfirmOpen} disabled={(!opbInfoStatus)}>
                                    수정
                                </button>
                            }
                            {mode === "capture" &&
                                <>
                                    <button className="button w100-button s-width-auto" style={{ width: "110px" }} onClick={this.handleCaptureButton} disabled={this.state.pubStatus}>
                                        원격캡쳐요청
                                </button>
                                    <button className={`button w100-button flower-blue-button`} variant="contained" color="primary" onClick={this.handleRefreshButton} disabled={this.state.pubStatus}>
                                        새로고침
                                </button>
                                </>
                            }
                            {mode === "floors" &&
                                <button className="button w100-button" variant="contained" color="primary" onClick={this.handleGoButton}>
                                    배포
                                </button>
                            }
                            {mode === "submit" &&
                                <>
                                    <button className={`button w100-button`} variant="contained" color="primary" onClick={this.handleConfirmOpen}>배포</button>
                                    <button className={`button w100-button`} variant="contained" color="primary" onClick={this.handleClickOpenPreview}>미리보기</button>
                                </>
                            }
                            {/* {mode === "screenModPC" &&
                                <>
                                    <button className={`button w100-button`} variant="contained" color="primary" onClick={this.handleConfirmOpen}>배포</button>
                                    <button className={`button w100-button`} variant="contained" color="primary" onClick={() => this.props.handleConfirm()}>취소</button>
                                </>
                            } */}
                            {/* {mode === "screenModMobile" &&
                                <>
                                    {(this.props.activeTabId === 1 || this.props.activeTabId === 2 || this.props.activeTabId === 3) &&
                                        <>
                                            <button className={`button w100-button`} variant="contained" color="primary" onClick={this.handleGoPrevButton}>이전</button>
                                            <button className={`button w100-button`} variant="contained" color="primary" onClick={this.handleGoNextButton}>다음</button>
                                        </>
                                    }
                                    {this.props.activeTabId === 4 &&
                                        <>
                                            <button className={`button w100-button`} variant="contained" color="primary" onClick={this.handleGoPrevButton}>이전</button>
                                            <button className="button w100-button" onClick={this.handleOpenPreview}>미리보기</button>
                                            <button className={`button w100-button`} variant="contained" color="primary" onClick={this.handleConfirmOpen}>배포</button>
                                        </>
                                    }
                                    {this.props.activeTabId === 5 &&
                                        <>
                                            <ContentsDel isMobile={true} handleContentsDel={this.handleContentsDel}/>
                                            <ContentsAdd siteID={siteID} opbID={opbID} opbNo={opbNo}
                                                contentTypeCode={this.props.contentTypeCode}
                                                coBeginDate={coBeginDate}
                                                coEndDate={coEndDate}
                                                isMobile={true}
                                                setContentListAdd={this.setContentListAdd}
                                            />
                                            <button className={`button w100-button`} variant="contained" color="primary" onClick={this.handleGoNextButton}>완료</button>
                                        </>
                                    }
                                </>
                            } */}

                        </div>
                        {mode === "mod" && this.state.open &&
                            <Confirm message={"수정하시겠습니까?"} kind={"save"} handleFormSubmit={this.handleModButton} handleClose={this.handleConfirmClose} />
                        }
                        {(mode === "submit" || mode === "screenModPC" || mode === "screenModMobile") && this.state.open &&
                            <Confirm message={(opbInfo.pubType === "derv" ? "예약" : "즉시") + "배포 하시겠습니까?"} kind={"save"} handleFormSubmit={this.handleSubmitButton} handleClose={this.handleConfirmClose} />
                        }
                    </>
                }
            </div>
        );
    }
}

function mapState(state) {
    const { userinfo } = state;
    const myInfo = userinfo.item;
    return { myInfo };
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(BottomButton);